import React, { FunctionComponent } from "react";
import FilterPanel from "./FilterPanel";
import StaffTable from "./StaffTable";
import TeacherDetailsModal from "../../../../../common/onboarding/second-step/teacher-details/TeacherDetailsModal";
import AssignEducatorsToCoachModal from "../../../../../common/onboarding/second-step/teacher-details/AssignEducatorsToEmployeeModal";
import AssignStudentsToTeacherModal from "../../../../../common/onboarding/second-step/teacher-details/AssignStudentsToEmployeeModal";

type OwnProps = {
  noStaffMembers: boolean;
  isLoadingStaff: boolean;
};

type Props = OwnProps;

const ManageUsersPage: FunctionComponent<Props> = ({ noStaffMembers, isLoadingStaff }) => {
  return (
    <div className="manageDistrictContainer manageUserDistrict mb-4">
      <h2 className="font-weight-bold mb-2">My Staff</h2>
      <h4>Invite and manage staff with ease—add or edit users, disable accounts, build coach–teacher relationships, and filter data to stay organized.</h4>
      <FilterPanel />
      <hr/>
      <StaffTable noStaffMembers={noStaffMembers} isLoadingStaff={isLoadingStaff} />
      <TeacherDetailsModal fromManageUsers/>
      <AssignEducatorsToCoachModal />
      <AssignStudentsToTeacherModal />
    </div>
  );
};

export default ManageUsersPage;
